export default __webpack_public_path__ + "static/media/flexline_black_logo_ee.7c1c9660.png";